"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenewPlanCard = void 0;

var _ = require("../..");

var _helpers = require("../../util/helpers");

var _react = _interopRequireWildcard(require("react"));

var _TRCToggle = _interopRequireDefault(require("../../TRCToggle"));

var _atoms = require("../../atoms");

require("./RenewPlanCard.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Prices
var ProductPriceDisplay = function ProductPriceDisplay(_ref) {
  var pairs = _ref.pairs,
      selectedPair = _ref.selectedPair,
      handleOnDidSelectPair = _ref.handleOnDidSelectPair;

  var onDidSelect = function onDidSelect() {
    if (typeof handleOnDidSelectPair === "function") {
      pairs[0]["title"] === selectedPair["title"] ? handleOnDidSelectPair(pairs[1]) : handleOnDidSelectPair(pairs[0]);
    }
  };

  if (pairs.length === 2) {
    return /*#__PURE__*/_react.default.createElement(_.Row, {
      alignItems: "center",
      justifyContent: "space-around",
      marginTop: "4",
      marginBottom: "4",
      width: "100%"
    }, /*#__PURE__*/_react.default.createElement(_.Label, {
      bold: true,
      color: selectedPair["title"] === pairs[0]["title"] ? _atoms.Color.Grey1 : _atoms.Color.Grey3,
      type: _.Label.Type.Body
    }, pairs[0]["title"]), /*#__PURE__*/_react.default.createElement(_TRCToggle.default, {
      trkAction: "Toggle Plan",
      checked: selectedPair["title"] === pairs[1]["title"],
      onToggle: onDidSelect
    }), /*#__PURE__*/_react.default.createElement(_.Label, {
      bold: true,
      color: selectedPair["title"] === pairs[1]["title"] ? _atoms.Color.Grey1 : _atoms.Color.Grey3,
      type: _.Label.Type.Body
    }, pairs[1]["title"]));
  } else {
    return /*#__PURE__*/_react.default.createElement(_.Label, {
      center: true,
      bold: true,
      className: "price-1",
      color: _atoms.Color.Grey1,
      marginBottom: "4"
    }, pairs[0]["title"]);
  }
}; // Renew Plan Card


var RenewPlanCard = function RenewPlanCard(_ref2) {
  var icon = _ref2.icon,
      title = _ref2.title,
      bullets = _ref2.bullets,
      selected = _ref2.selected,
      recommended = _ref2.recommended,
      subtitleTop = _ref2.subtitleTop,
      forceExpand = _ref2.forceExpand,
      subtitleBottom = _ref2.subtitleBottom,
      productPricePairs = _ref2.productPricePairs,
      handleDidSelectPlan = _ref2.handleDidSelectPlan,
      collapseByDefault = _ref2.collapseByDefault,
      handleDidSelectPurchasePlan = _ref2.handleDidSelectPurchasePlan;
  var isMobile = (0, _helpers.isMobileScreen)();
  var startingExpanded = !!forceExpand ? true : collapseByDefault ? false : false || selected;

  var _useState = (0, _react.useState)(startingExpanded),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var _useState3 = (0, _react.useState)(productPricePairs[0]),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedPair = _useState4[0],
      setSelectedPair = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      didSelect = _useState6[0],
      setDidSelect = _useState6[1];

  var cn = expanded ? "RenewPlanCard expanded" : "RenewPlanCard";
  if (recommended) cn += " recommended";
  if (selected) cn += " selected";
  (0, _react.useEffect)(function () {
    if (!forceExpand && didSelect) {
      if (selected) {
        setExpanded(true);
        cn += " selected";
      } else {
        setExpanded(false);
        cn.replace(" selected", "");
      }
    }
  }, [selected, forceExpand, didSelect]);

  var handleOnDidSelectPair = function handleOnDidSelectPair(pair) {
    setSelectedPair(pair);
  };

  return /*#__PURE__*/_react.default.createElement(_.Column, {
    key: title,
    justifyContent: "space-between",
    className: cn,
    onClick: function onClick(e) {
      setDidSelect(true);
      handleDidSelectPlan(title);
    }
  }, /*#__PURE__*/_react.default.createElement(_.Element, {
    className: "top"
  }, recommended && /*#__PURE__*/_react.default.createElement(_.Label, {
    bold: true,
    center: true,
    className: "recommended"
  }, "RECOMMENDED"), /*#__PURE__*/_react.default.createElement(_.Row, {
    className: "top-container",
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_.Label, {
    className: "title",
    type: _.Label.Type.Heading4
  }, title), icon && /*#__PURE__*/_react.default.createElement(_.Row, {
    justifyContent: "flex-end"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "icon",
    src: icon
  }))), subtitleTop && /*#__PURE__*/_react.default.createElement(_.Label, {
    className: "subtitle-top",
    marginBottom: "4",
    color: _atoms.Color.Grey1
  }, subtitleTop), expanded && bullets && /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-bullets"
  }, bullets.map(function (bullet, index) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: "renew-plan-card-li-".concat(index)
    }, /*#__PURE__*/_react.default.createElement(_.Label, {
      color: _atoms.Color.Grey1,
      className: "bullet",
      type: _.Label.Type.Body
    }, bullet));
  }))), expanded && /*#__PURE__*/_react.default.createElement(_.Element, {
    className: "bottom"
  }, /*#__PURE__*/_react.default.createElement(ProductPriceDisplay, {
    pairs: productPricePairs,
    selectedPair: selectedPair,
    handleOnDidSelectPair: handleOnDidSelectPair
  }), /*#__PURE__*/_react.default.createElement(_.Button, {
    trkAction: "Purchase ".concat(title, " Pressed"),
    primary: true,
    className: "button-purchase",
    content: /*#__PURE__*/_react.default.createElement(_.Row, {
      className: "content"
    }, recommended && /*#__PURE__*/_react.default.createElement(_.Icon, {
      type: _.Icon.Type.Upgrade
    }), /*#__PURE__*/_react.default.createElement(_.Label, {
      marginLeft: "2"
    }, "Purchase")),
    onClick: function onClick(e) {
      return handleDidSelectPurchasePlan(title, selectedPair);
    }
  }), (isMobile && subtitleBottom || !isMobile) && /*#__PURE__*/_react.default.createElement(_.Label, {
    bold: true,
    center: true,
    type: _.Label.Type.SmallBody,
    className: "subtitle-bottom",
    marginTop: "4"
  }, subtitleBottom)));
};

exports.RenewPlanCard = RenewPlanCard;
RenewPlanCard.defaultProps = {
  collapseByDefault: false
};